module.exports = __webpack_public_path__ + "img/clipboard-prescription.fc3ff4b6.svg";